import { SearchResult } from './search-query-builder.component';

export class SearchResultBuilder {
  static empty(): SearchResult {
    return {
      rawQuery: '',
      tokens: [],
      qualifiers: {},
      regexes: {},
      textTerms: [],
      hasLogicalOperators: false,
      groups: 0,
      implicitAnd: false
    };
  }
}
